import { render, staticRenderFns } from "./downloadTrilha.vue?vue&type=template&id=e4b6fe4e"
import script from "./downloadTrilha.vue?vue&type=script&lang=js"
export * from "./downloadTrilha.vue?vue&type=script&lang=js"
import style0 from "./downloadTrilha.vue?vue&type=style&index=0&id=e4b6fe4e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports